<template>
  <div>
    <modal-layout-top title="Fortnox connection log" />
    <div class="content slider-modal" v-if="display">
      <table class="log-table">
        <thead>
          <tr>
            <th class="right date-time">Date/time</th>
            <th class="left event">Event</th>
            <th class="left">User</th>
            <th class="left">Request</th>
            <th class="left">Status</th>
            <th class="left">Reponse</th>
            <th class="left">Log</th>
            <th class="left">Error</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="log in fortnoxConnectionLogs.items" :key="log.fortnoxConnectionLogId">
            <td class="right">{{ log.dateTimeDisplay }}</td>
            <td class="left">{{ log.event }}</td>
            <td class="left">{{ log.user.initials }}</td>
            <td class="left">{{ log.requestBody || '—' }}</td>
            <td class="left">{{ log.statusCode || '—' }}</td>
            <td class="left">{{ log.responseBody || '—' }}</td>
            <td class="sub-log" v-html="log.subLog"></td>
            <td class="left">{{ log.error || '—' }}</td>
          </tr>
        </tbody>
      </table>
      <modal-layout-buttons hide-save  />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ModalLayoutTop from '@/components/modals/ModalLayoutTop'
import ModalLayoutButtons from '@/components/modals/ModalLayoutButtons'

export default {
  components: {
    ModalLayoutTop,
    ModalLayoutButtons
  },
  data () {
    return {
      display: false
    }
  },

  computed: {
    ...mapState({
      fortnoxConnectionLogs: state => state.fortnoxConnectionLogs.all
    })
  },

  created () {
    this.$store.dispatch('fortnoxConnectionLogs/getListData').then(() => {
      setTimeout(() => {
        this.fortnoxConnectionLogs.items.forEach(log => {
          if (log.subLog) {
            log.subLog = log.subLog.replace(/\r\n/g, '<br>')
            console.log(log.subLog)
          }
        })
        this.display = true
      }, 10)
    })
  }
}
</script>

<style lang="scss" scoped>
.log-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  font-size: 0.75rem;

  .date-time {
    width: 130px;
  }
  .left {
   text-align: left;
  }
  .right {
   text-align: right;
  }

  th, td {
    padding: 0 10px;
    border-bottom: 1px solid #ddd;
  }

  th {
    background-color: #f2f2f2;
  }

  .event {
    width: 130px;
  }

  .sub-log {
    max-height: 200px;
    text-wrap: wrap;
    overflow-wrap: anywhere;
    width: 500px;
    text-align: left;
    box-sizing: border-box;
    color: #000;
    background-color: transparent;
    font-family: 'Courier New', Courier, monospace;
    font-size: 0.6rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/FortnoxConnectionLogModal.vue